import { useFlags } from 'launchdarkly-react-client-sdk';

import SupportSystemOld from './supportSystem';
import SupportSystemNew from './supportSystemNew';

export const SupportSystem = () => {
  const { enablePccAndPcpFields } = useFlags();

  return enablePccAndPcpFields ? <SupportSystemNew /> : <SupportSystemOld />;
};
